<template>
  <div class="HomeBox">
    <div class="homeHeader">
      <div class="searchBox">
        <div class="searchInfo">
          <div class="searchText">{{ $t.home.title }}</div>
          <div class="moreButton" @click="onShowEmit('showUserLanguages')">
            <img src="~assets/img/home/language.png" />
          </div>
        </div>
      </div>
    </div>

    <div class="homeContent">
      <banner :images="images" />
      <div class="information-background"></div>
      <information :homeData="homeData"></information>
      <search-bar></search-bar>
      <icon-list />
      <product-List
        :productList="productList"
        :pageIndex="pageIndex"
        :pageSize="pageSize"
        @handleSwitch="handleSwitch"
      ></product-List>
    </div>

    <div class="kefu" @click="gotoKefuList">
      <van-image width="50" height="50" fit="fill" round :src="kefuIcon"></van-image>
    </div>

    <radio-list
      :title="$t.meta.systemLanguage"
      event="showUserLanguages"
      :value="Language"
      :options="langOptions"
      @onSelect="onSelectLanguage"
    ></radio-list>
  </div>
</template>
<script>
import Vue from "vue";
import Information from "./components/Information";
import Banner from "./components/Banner";
import SearchBar from "./components/SearchBar";
import IconList from "./components/IconList";
import ProductList from "./components/ProductList";
import { isAPP } from "@/plugins/environment/type.js";
import { Swipe, SwipeItem, List, Image } from "vant";
import RadioList from "@components/radioList/RadioList.vue";

Vue.use(Swipe).use(SwipeItem).use(List).use(Image);

export default {
  name: "Home",
  components: {
    Banner,
    IconList,
    SearchBar,
    Information,
    RadioList,
    ProductList,
  },
  data() {
    return {
      kefuIcon: require("@/assets/img/home/kefu.jpg"),
      env: isAPP(), // 当前环境
      images: [],
      homeData: {},
      //多语言
      Language: localStorage.getItem("language") || "auto",
      langOptions: [],
      //商品列表
      productList: [],
      pageIndex: 1,
      pageSize: 3,
      lastPage: 1,
      refresh: false,
    };
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    gotoKefuList() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "kefuList",
        name: "kefuList",
        query: [],
      });
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.loadHome(), this.loadProducts()]).then((success) => {
          if (success) {
            resolve(true);
          }
          this.$commonMethod.hideLoading();
        });
      });
    },
    loadHome() {
      return new Promise((resolve, reject) => {
        let param = {};
        this.$api.home
          .loadPurchasingSystemHome(param)
          .then((res) => {
            this.homeData = res.data;
            this.images = res.data.AdvertList;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject(true);
          });
      });
    },
    handleSwitch(page) {
      if (this.pageIndex == this.lastPage) {
        this.pageIndex = 1;
        this.$commonMethod.showToast({
          type: "success",
          titleMsg: this.$t.meta.noMore,
        });
      } else {
        this.pageIndex = page;
      }
      this.loadProducts();
    },
    loadProducts() {
      return new Promise((resolve, reject) => {
        let param = {
          PageIndex: this.pageIndex,
          PageSize: this.pageSize,
        };
        this.$api.product
          .loadShopProductsByPage(param)
          .then((res) => {
            this.productList = res.data.Data;
            this.lastPage = res.meta.lastPage;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject(true);
          });
      });
    },
    onSelectLanguage(value) {
      localStorage.setItem("language", value);
      this.$commonEnv.commonAction(this.$commonEnv.actionType.refresh);
    },
    onShowEmit(emit) {
      this.langOptions = [
        { text: this.$t.meta.autoLanguage, value: "auto" },
        { text: "中文", value: "zh" },
        { text: "English", value: "en" },
        { text: "العربية", value: "ar" },
      ];
      this.$bus.$emit(emit, true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.HomeBox {
  $-headerhight: 50px;
  .homeHeader {
    position: fixed;
    top: 0;
    left: 0;
    padding-top: calc(env(safe-area-inset-top));
    z-index: 999;
    width: 100%;
    height: 50px;
    background: linear-gradient(left, #132660, #2750aa);
    .searchBox {
      z-index: 10;
      width: 100%;
      line-height: 50px;
      text-align: center;
      background: linear-gradient(left, #132660, #2750aa);
      .searchInfo {
        position: relative;
        .searchText {
          display: inline-block;
          font-size: 18px;
          color: #ffffff;
        }
        .moreButton {
          position: absolute;
          right: 4%;
          top: 4%;
          img {
            height: 20px;
            width: 20px;
            object-fit: contain;
          }
        }
      }
    }
  }
  .homeContent {
    margin-top: $-headerhight;
    display: inline-block;
    width: 100%;
  }
  .privacy-alert {
    padding: 5%;
    font-size: 14px;
    line-height: 2;
  }
  .shopBox {
    padding: 0 10px;
    box-sizing: border-box;
  }
  .information-background {
    height: 100px;
    width: 100%;
    position: absolute;
    background: linear-gradient(left, #132660, #2750aa);
    z-index: -1;
  }
  .kefu {
    position: fixed;
    right: 8px;
    bottom: 60px;
    z-index: 999;
    border-radius: 100px;
    border: 2px solid #132660;
    width: 50px;
    height: 50px;
  }
}
</style>
